import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Suggestion, SuggestionCategory } from '..';

interface ApiResponse<T> {
  count: number;
  result: T[];
}

interface CreateSuggestionRequest {
  Text: string;
}

@Injectable({
  providedIn: 'root',
})
export class SuggestionService {
  private readonly baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  loadCategories(): Observable<SuggestionCategory[]> {
    return this.http
      .get<
        ApiResponse<SuggestionCategory>
      >(`${this.baseUrl}/suggestion-text-categories`)
      .pipe(map((response) => response.result));
  }
  loadSuggestionsByCategory(categoryId: number): Observable<Suggestion[]> {
    return this.http
      .get<
        ApiResponse<Suggestion>
      >(`${this.baseUrl}/suggestion-text-categories/${categoryId}/suggestion-texts`)
      .pipe(map((response) => response.result));
  }

  addSuggestion(categoryId: number, text: string): Observable<void> {
    const request: CreateSuggestionRequest = { Text: text };
    const url = `${this.baseUrl}/suggestion-text-categories/${categoryId}/suggestion-texts`;
    return this.http.post<void>(url, request);
  }

  removeSuggestion(categoryId: number, suggestionId: number): Observable<void> {
    return this.http.delete<void>(
      `${this.baseUrl}/suggestion-text-categories/${categoryId}/suggestion-texts/${suggestionId}`
    );
  }
}
